import { render, staticRenderFns } from "./MultiSelectModal.vue?vue&type=template&id=247b4d85&scoped=true&"
import script from "./MultiSelectModal.vue?vue&type=script&lang=js&"
export * from "./MultiSelectModal.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectModal.vue?vue&type=style&index=0&id=247b4d85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b4d85",
  null
  
)

export default component.exports